module.exports = __webpack_public_path__ + "static/media/perm-makeup-selected.21895e26.png";